import mediaQueries from '../constants/mediaQueries'

/**
 * Return the responsive classes (JSS unique CSS selector) for an element given the defined prefix and values.
 * @param {(number|string|Object)} propValue - The property value.
 * @param {(number|string)} [propValue.sm] - The property value for 'sm' media query.
 * @param {(number|string)} [propValue.md] - The property value for 'md' media query.
 * @param {(number|string)} [propValue.lg] - The property value for 'lg' media query.
 * @param {string} prefix - The class prefix for each class defined.
 * @param {Object} useStyles - The object returned by jss-react useStyles function.
 */
export function stylesClasses(propValue, prefix, useStyles) {
	if (typeof propValue === 'number' || typeof propValue === 'string') {
		const key = prefix + propValue

		return useStyles[key]
	}

	if (typeof propValue !== 'object') {
		return null
	}

	return Object.keys(propValue)
		.reduce((selectors, mq) => {
			if (!mediaQueries[mq]) {
				return selectors
			}

			const key = generateKey(prefix, propValue[mq], mq)

			return `${selectors} ${useStyles[key]}`
		}, '')
		.trim()
}

/**
 * Return the css selector key for the JSS styles object.
 * @param {string} prefix - The class prefix for each class defined.
 * @param {(number|string|boolean} value - The property value.
 * @param {Object} useStyles - The object returned by jss-react useStyles function.
 * @return {string} [example]: generateKey("col--", "10", "md") -> "col--md-10"
 */
export function generateKey(prefix, value, mediaQuery = null) {
	if (!mediaQuery) {
		if (value === true) {
			return `${prefix}${value}`
		}
	}

	if (value === true) {
		return `${prefix}${mediaQuery}`
	}

	if (mediaQuery === 'sm') {
		return `${prefix}${value}`
	}

	return `${prefix}${mediaQuery}-${value}`
}

/**
 * Return the css selector for the given classes.
 * @param {string} classes - Classes string.
 * @return {string} [example]: cssSelector("Vb-col Vb-col--sm-5") -> ".Vb-col.Vb-col--sm-5"
 */
export function cssSelector(classes) {
	if (!classes) return ''

	return '.' + classes.replaceAll(' ', '.')
}
